"use client";

import dynamic from "next/dynamic";

const Publikasi = dynamic(() => import("@/app/Components/Pages/Publikasi"), {
    ssr: false
});

export default function PublikasiWrapper() {
  return <Publikasi />;
}
